import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    fieldCustomClasses: {
      width: "512px",
    }
  };
});
